module.exports = "<div ui-view layout-fill></div>\n"


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tpl.html
// module id = 1221
// module chunks = 0